import React from 'react'
import { Select, MenuItem, Typography } from '@material-ui/core'
import { TASK_STATUS, TASK_STATUS_LABELS, TASK_STATUS_COLORS } from '../../constants/bidStatuses'

const rowStyle = {
  padding: '8px 0',
  borderBottom: '1px solid #f0f0f0',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  cursor: 'pointer',
  gap: 8
}

const TaskRow = ({ task, onEdit, onStatusChange }) => {
  const isOverdue = task.dueDate && new Date(task.dueDate) < new Date() && task.status !== 'complete'
  const ownerName = task.owner?.name || 'Unassigned'
  const initials = ownerName.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2)

  return (
    <div style={rowStyle} onClick={() => onEdit(task)}>
      <div style={{ flex: 1, minWidth: 0 }}>
        <Typography variant="body2" style={{ fontWeight: 500, fontSize: 13 }} noWrap>
          {task.title}
        </Typography>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 2 }}>
          <span style={{
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            width: 22, height: 22, borderRadius: '50%',
            backgroundColor: '#e0e0e0', fontSize: 10, fontWeight: 600
          }}>
            {initials}
          </span>
          {task.assignees?.length > 1 && (
            <span style={{ fontSize: 11, color: '#999' }}>+{task.assignees.length - 1}</span>
          )}
          {task.dueDate && (
            <span style={{ fontSize: 11, color: isOverdue ? '#f44336' : '#999' }}>
              {new Date(task.dueDate).toLocaleDateString()}
            </span>
          )}
        </div>
      </div>
      <Select
        value={task.status}
        onClick={(e) => e.stopPropagation()}
        onChange={(e) => {
          e.stopPropagation()
          onStatusChange(task._id, e.target.value)
        }}
        disableUnderline
        style={{ fontSize: 11, minWidth: 0 }}
        renderValue={(val) => (
          <span style={{
            backgroundColor: TASK_STATUS_COLORS[val] || '#9e9e9e',
            color: '#fff', padding: '2px 8px', borderRadius: 10, fontSize: 11
          }}>
            {TASK_STATUS_LABELS[val] || val}
          </span>
        )}
      >
        {Object.values(TASK_STATUS).map(s => (
          <MenuItem key={s} value={s} style={{ fontSize: 12 }}>
            {TASK_STATUS_LABELS[s]}
          </MenuItem>
        ))}
      </Select>
    </div>
  )
}

export default TaskRow
